export default {
	lang:'ko',
	download:{
		"download01":"윈도우",
		"download02":"스코틀랜드 사람",
		"download03":"iOS",
		"download04":"기계적 인조 인간",
		"download05":"지금 다운로드",
		"download":"다운로드",
		"download2":"이동하는",
		"download3":"QR 코드를 스캔하여 iOS/Android를 다운로드하세요",
		"download4":"QR 코드",
		"download5":"윈도우",
		"download6":"64비트 Windows 10 이상 지원",
		"download7":"맥OS",
		"download8":"MacOS 10.14 이상 지원",
		"download9":"앱 스토어",
		"download10":"MacOS 10.14 이상 지원",
		"download11":"기계적 인조 인간",
		"download12":"Android 10.14 이상 지원",
	},
	home:{
		"home":"첫 페이지",
		"XiaobeiBigModel":"작은 모델",
		"AIcapability":"AI 기능",
		"Solution":"해결책",
		"ProductCenter":"제품 센터",
		"MediaCenter":"미디어 센터",
		"AboutUs":"우리에 대해",
		"Login/Regis":"로그인/등록",
		"home1":"핵심 역량",
		"home2":"고객 서비스 핫라인",
		"home3":"연락처 번호",
		"home14":"지능형 하드웨어를 캐리어로 사용하는 AI 강화는 풀스택 기능과 서비스를 제공합니다.",
		"home15":"퍼즐 알고리즘",
		"home16":"OCR 인식",
		"home17":"AI 인텔리전스",
		"home18":"음성 인식",
		"home19":"권위 있는 사전",
		"home20":"텍스트 번역",
		"home21":"사진 번역",
		"home22":"일반 Q&amp;A",
		"home23":"비디오 강좌",
		"home24":"Xiaobei AI 대형 모델",
		"home25":"기술은 생산의 주요 원동력이다",
		"home26":"기술 직원",
		"home27":"연구개발 투자",
		"home28":"특허 수",
		"home29":"(백분율)",
		"home30":"(1억 위안)",
		"home31":"(목)",
		"home32":"해결책",
		"home33":"사무실, 교육, 차량용 박스 등 다양한 시나리오의 적용 요구에 직면한 BeiBo는 자체 R&amp;D 역량과 서비스 컨셉을 기반으로 고객에게 원스톱 솔루션을 제공합니다.",
		"home34":"관련 솔루션",
		"home35":"관련 제품 기능",
		"home36":"풀스택 서비스",
		"home37":"지능형 하드웨어를 캐리어로 사용하는 AI 강화는 풀스택 기능과 서비스를 제공합니다.",
		"home38":"연구개발",
		"home39":"생산",
		"home40":"품질 관리",
		"home41":"애프터 서비스 지원",
		"home42":"OCR, 음성 인식, 번역, AI 및 인간-컴퓨터 상호 작용 R&amp;D 역량을 다년간 보유한 전문 소프트웨어 및 하드웨어 R&amp;D 팀",
		"home43":"원산지 공장, 안정적인 공급망, 엄격한 지능형 공정 생산",
		"home44":"품질 검사원이 모든 단계를 점검하고 ISO9001 관리 시스템을 도입합니다.",
		"home45":"국내외 전문적인 애프터 서비스 지원팀을 구축하여 시기적절한 대응, 집중적인 솔루션, 일대일 서비스를 제공합니다.",
		"home46":"인증",
		"home47":"국내외 특허 100여건 이상 보유",
		"home48":"소식",
		"home49":"최신 뉴스를 알아보세요",
		"home50":"세부 사항을 확인하세요",
		"home51":"파트너",
		"home52":"인공지능 하드웨어 시장에 집중하고 전문적인 OEM/0DM 서비스를 제공합니다.",
		"home53":"협력 상담",
		"home54":"스마트 오피스",
		"home55":"스마트 교육",
		"home56":"스마트카 박스",
		"home57":"음성 인식",
		"home58":"퍼즐 알고리즘",
		"home59":"OCR 인식",
		"home60":"음성 합성",
		"home61":"텍스트 번역",
		"home62":"이미지 번역",
		"home63":"음성 번역",
		"home64":"자연어 처리",
		"home571":"OCR 인식",
		"home581":"음성 인식 ",
		"home591":"음성 번역",
		"home601":"음성 합성",
		"home611":"권위 있는 사전",
		"home621":"일반 과정",
		"home631":"일반 Q&amp;A",
		"home641":"자연어 처리",
		"home572":"음성 인식",
		"home582":"음성 합성 ",
		"home592":"음성 번역",
		"home602":"자연어 처리",
		"home603":"더 이상은 없다",
	},
	consult:{
		"tilte":"저희는 귀하에게 모든 비즈니스 협력 서비스를 진심으로 제공하겠습니다.",
		"subtilte":"연락처를 남겨주시면 최대한 빨리 연락드리겠습니다.",
		"name":"이름을 입력해주세요",
		"phone":"전화번호를 입력해주세요",
		"mailbox":"이메일을 입력해주세요",
		"mailboxerr":"이메일 형식 오류",
		"company":"귀하의 회사를 입력하세요",
		"desc":"귀하의 요구 사항을 입력하세요",
		"but":"제출 확인",
		"region":"중국",
		"select":"선택해주세요",
		"submitSuccess":"성공적으로 제출되었습니다",
		"submitError":"제출에 실패했습니다",
	},
	ProDetails:{
		"ProDetails1":"맞춤형 프로세스",
		"ProDetails2":"인공지능 하드웨어 시장에 집중하고 전문적인 OEM/0DM 서비스를 제공합니다.",
	},
	aiCapacity:{
		"aiMode1":"AI 기능",
		"aiMode2":"빅데이터, 지식 그래프, 머신러닝, 언어학 등의 기술을 기반으로, 우리는 혁신을 지속하고 AI 핵심 기술 연구와 스마트 하드웨어 애플리케이션 구현에 집중하고 있습니다.",
		"aiMode3":"협력 상담",
		"aiMode4":"핵심 역량",
		"aiMode5":"지능형 하드웨어를 캐리어로 사용하는 AI 강화는 풀스택 기능과 서비스를 제공합니다.",
		"aiMode6":"퍼즐 알고리즘",
		"aiMode7":"50개 이상의 언어를 지원하여 인식을 위해 작은 조각난 이미지를 큰 이미지로 병합합니다.",
		"aiMode8":"OCR 인식",
		"aiMode9":"이미지 처리 및 패턴 인식 기술을 통해 텍스트를 추출합니다. 50개 이상의 언어를 지원합니다.",
		"aiMode10":"음성 인식",
		"aiMode11":"길고 짧은 오디오를 텍스트로 정확하게 인식합니다. 130개 이상의 언어를 지원합니다.",
		"aiMode12":"음성 합성",
		"aiMode13":"텍스트를 자연스럽고 유창한 사람의 목소리로 변환합니다. 130개 이상의 언어를 지원합니다.",
		"aiMode14":"텍스트 번역",
		"aiMode15":"대상 언어의 텍스트를 지정된 언어로 변환합니다. 130개 이상의 언어를 지원합니다.",
		"aiMode16":"이미지 번역",
		"aiMode17":"이미지 텍스트 인식 및 번역. 130개 이상의 언어 지원",
		"aiMode18":"음성 번역",
		"aiMode19":"길고 짧은 오디오를 정확하게 인식하고 번역합니다. 130개 이상의 언어를 지원합니다.",
		"aiMode20":"자연어 처리",
		"aiMode21":"빅데이터, 지식, 언어기술을 기반으로 질의응답, 대화 등의 응용이 가능합니다.",
		"aiMode22":"사전 권위",
		"aiMode23":"옥스포드, 롱맨 등 권위 있는 기관과 긴밀히 협력하여 다양한 소수 언어 사전을 제공합니다.",
		"aiMode24":"비디오 강좌",
		"aiMode25":"전체 과목 비디오 강좌, 교과서가 동시에 업데이트되어 미리 보기 및 검토에 적합합니다.",
		"aiMode26":"일반 Q&amp;A",
		"aiMode27":"모든 과목의 질문에 답하고 해석하며, 유추를 통해 학습하고 학습 효율성을 향상시킵니다.",
		"aiMode28":"Xiaobei AI 대형 모델",
		"aiMode29":"다중 모드 상호작용",
		"aiMode30":"텍스트, 음성 및 비디오 다중 모달 상호 작용",
		"aiMode31":"코딩 능력",
		"aiMode32":"코드 생성, 해석, 디버깅, 테스트",
		"aiMode33":"텍스트 생성",
		"aiMode34":"에세이, 마케팅, 보도자료 등의 제작",
		"aiMode35":"일반 진료",
		"aiMode36":"모든 과목에 대한 질문 설정 및 문제 해결",
		"aiMode37":"언어 이해",
		"aiMode38":"추상 추출, 문법 검사, 감정 분석",
		"aiMode39":"하찮은 일",
		"aiMode40":"삶, 일, 의학, 역사에 대한 지식",
		"aiMode41":"논리적 추론",
		"aiMode42":"사고, 과학, 상식적 추론",
		"aiMode43":"다국어",
		"aiMode44":"100개 이상의 언어로 상호 작용 지원",
		"aiMode45":"기술적 장점",
		"aiMode46":"2억 개의 정확한 코퍼스",
		"aiMode47":"스마트 오피스, 스마트 교육, 스마트 카 박스 등에 널리 활용",
		"aiMode48":"글로벌 협업 기술",
		"aiMode49":"초저지연, 안전하고 안정적이며, 지능형 스케줄링, 안정적인 링크",
		"aiMode50":"보안 암호화 시스템",
		"aiMode51":"국제적으로 선도하는 클라우드-파이프-엔드-데이터 4차원 암호화 시스템, 전체 프로세스 암호화",
	},
	aiMode:{
		"aiMode1":"AI 기능",
		"aiMode2":"빅데이터, 지식 그래프, 머신러닝, 언어학 등의 기술을 기반으로, 우리는 혁신을 지속하고 AI 핵심 기술 연구와 스마트 하드웨어 애플리케이션 구현에 집중하고 있습니다.",
		"aiMode3":"협력 상담",
		"aiMode4":"핵심 역량",
		"aiMode5":"지능형 하드웨어를 캐리어로 사용하는 AI 강화는 풀스택 기능과 서비스를 제공합니다.",
		"aiMode6":"퍼즐 알고리즘",
		"aiMode7":"50개 이상의 언어를 지원하여 인식을 위해 작은 조각난 이미지를 큰 이미지로 병합합니다.",
		"aiMode8":"OCR 인식",
		"aiMode9":"이미지 처리 및 패턴 인식 기술을 통해 텍스트를 추출합니다. 50개 이상의 언어를 지원합니다.",
		"aiMode10":"음성 인식",
		"aiMode11":"길고 짧은 오디오를 텍스트로 정확하게 인식합니다. 130개 이상의 언어를 지원합니다.",
		"aiMode12":"음성 합성",
		"aiMode13":"텍스트를 자연스럽고 유창한 사람의 목소리로 변환합니다. 130개 이상의 언어를 지원합니다.",
		"aiMode14":"텍스트 번역",
		"aiMode15":"대상 언어의 텍스트를 지정된 언어로 변환합니다. 130개 이상의 언어를 지원합니다.",
		"aiMode16":"이미지 번역",
		"aiMode17":"이미지 텍스트 인식 및 번역. 130개 이상의 언어 지원",
		"aiMode18":"음성 번역",
		"aiMode19":"길고 짧은 오디오를 정확하게 인식하고 번역합니다. 130개 이상의 언어를 지원합니다.",
		"aiMode20":"자연어 처리",
		"aiMode21":"빅데이터, 지식, 언어기술을 기반으로 질의응답, 대화 등의 응용이 가능합니다.",
		"aiMode22":"사전 권위",
		"aiMode23":"옥스포드, 롱맨 등 권위 있는 기관과 긴밀히 협력하여 다양한 소수 언어 사전을 제공합니다.",
		"aiMode24":"비디오 강좌",
		"aiMode25":"전체 과목 비디오 강좌, 교과서가 동시에 업데이트되어 미리 보기 및 복습에 적합합니다.",
		"aiMode26":"일반 Q&amp;A",
		"aiMode27":"모든 과목의 질문에 답하고 해석하며, 유추를 통해 학습하고 학습 효율성을 향상시킵니다.",
		"aiMode28":"Xiaobei AI 대형 모델",
		"aiMode29":"다중 모드 상호작용",
		"aiMode30":"텍스트, 음성 및 비디오 다중 모달 상호 작용",
		"aiMode31":"코딩 능력",
		"aiMode32":"코드 생성, 해석, 디버깅, 테스트",
		"aiMode33":"텍스트 생성",
		"aiMode34":"에세이, 마케팅, 보도자료 등의 제작",
		"aiMode35":"일반 진료",
		"aiMode36":"모든 과목에 대한 질문 설정 및 문제 해결",
		"aiMode37":"언어 이해",
		"aiMode38":"추상 추출, 문법 검사, 감정 분석",
		"aiMode39":"하찮은 일",
		"aiMode40":"삶, 일, 의학, 역사에 대한 지식",
	},
	Product:{
		"Product1":"제품 센터",
		"Product2":"사무실, 교육 및 차량용 스마트 제품, 주문 및 기능 맞춤화 지원",
		"Product3":"협력 상담",
	},
	medium:{
		"medium1":"미디어 센터",
		"medium2":"베이보의 최신 소식은 여기를 참조하세요",
		"medium3":"협력 상담",
	},
	about:{
		"about1":"BeiBo에 대해 자세히 알아보세요",
		"about2":"사무실, 교육, 자동차 박스 등을 위한 스마트 하드웨어 솔루션 공급업체",
		"about3":"협력 상담",
		"about4":"회사 프로필",
		"about5":"인증",
		"about6":"국내외 특허 100여건 이상 보유",
		"about7":"심천 베이보 인텔리전트 테크놀로지 유한회사",
		"about8":"2015년에 설립되어 중국의 &quot;스마트 제조&quot; 중심지인 선전에 본사를 둔 BeiBo Intelligent는 국가적 첨단 기술 기업이자 미래 지향적 비전과 혁신 정신을 갖춘 전문적이고 혁신적인 기업입니다.",
		"about9":`이 회사는 AI 음성의 수직적 부문에 집중하고 있으며, 강력한 AI 소프트웨어 + 하드웨어 R&amp;D 역량을 보유하고 있습니다. AI 음성, AI 번역, AI OCR, AI 인간-차량 상호작용, AI 클라우드와 같은 AI 기술을 수출하여 AI 하드웨어를 강화합니다. 이 회사는 자체 음성 번역 AI 모델을 개발하고, 최신 AI 멀티모달 및 AIGC 기술을 통합하며, 칩 플랫폼 및 하드웨어 솔루션의 R&amp;D 및 설계를 기반으로 다양한 분야의 고객에게 풀스택 AI 음성 기술 솔루션을 제공합니다. 교육, 정부, 기업 및 군사 분야에서 이 회사는 성숙한 산업 솔루션을 보유하고 있으며, 소비자 측면에서는 AI 번역기, AI 음성 녹음기, AI 스캐너, AI 카박스와 같은 AI 하드웨어의 연간 판매량이 100만 대를 넘습니다. 이 회사는 일본, 유럽, 미국 및 기타 국가 및 지역에 여러 전략적 파트너를 두고 인간이 언어 장벽을 극복할 수 있도록 지원하며, AI 음성 기술 솔루션의 글로벌 선도 공급업체입니다.`,
		"about10":"",
	},
	footer:{
		"AboutUs":"우리에 대해",
		"CollaborativeConsulting":"협력 상담",
		"Businesscooperation":"사업 협력",
		"phone":"전화번호를 입력해주세요",
		"phone2":"+86 13660736734",
		"phone3":"hangou@szbbzn.com",
		"tel":"0755 27189290",
		"address":"선전시 룽화구 다랑가 타오위안 커뮤니티 위안펀 공업지대 F동 201호",
		"copyright":"저작권 © 심천 베이보 인텔리전트 테크놀로지 유한회사",
		"icp":"광동 ICP 번호 2024241358-1",
		"footer2":"등록을 환영합니다",
		"footer3":"이미 계정이 있으신가요?",
		"footer4":"로그인해주세요",
	},
	login:{
		"login1":"비밀번호 로그인",
		"login2":"SMS 로그인",
		"loginTab3":"이메일 로그인",
		"login3":"우편",
		"login4":"로그인 비밀번호",
		"login5":"전화 번호",
		"login6":"선택해주세요",
		"login7":"모바일 인증 코드",
		"login8":"로그인",
		"login9":"비밀번호를 잊어버리다",
		"login10":"등록하다",
		"login11":"로그인하면 동의합니다",
		"login12":"서비스 계약",
		"login13":"개인정보 보호정책",
		"login14":"얻다",
		"login15":"중국",
		"login16":"계좌번호를 입력해주세요",
		"login17":"비밀번호를 입력하세요",
		"login18":"로그인이 성공했습니다!",
		"login19":"인증번호를 입력하세요!",
		"login20":"성공적으로 전송되었습니다!",
		"login21":"그리고",
		"login22":"음성 녹음기 클라우드 디스크",
		"login23":"내 글",
		"login24":"내 대화",
		"login25":"계정 보안",
		"login26":"로그아웃",
		"login27":"이메일을 통해 비밀번호 찾기",
		"login28":"우편",
		"login29":"이메일 인증 코드",
		"login30":"로그인 비밀번호 설정 (6~16자)",
		"login31":"로그인 비밀번호를 다시 입력하세요",
		"login32":"제출하다",
		"login33":"로그인으로 돌아가기",
		"login34":"수정이 성공했습니다!",
	},
	register:{
		"register1":"전화 번호",
		"register2":"전화번호를 입력해주세요",
		"register3":"선택해주세요",
		"register4":"모바일 인증 코드",
		"register5":"비밀번호 설정",
		"register6":"인증번호를 입력해주세요",
		"register7":"6~16자",
		"register8":"비밀번호 확인",
		"register9":"우편",
		"register10":"이메일 주소를 입력해주세요",
		"register11":"이메일 인증 코드",
		"register12":"인증번호를 입력해주세요",
		"register13":"나는 읽었고 동의합니다",
		"register14":"동의하시는 항목을 읽고 체크해 주세요.",
		"register15":"전화번호 형식이 올바르지 않습니다/전화번호가 등록되었습니다",
		"register16":"모바일 인증 코드 오류",
		"register17":"이메일 주소를 입력해 주세요 / 이메일 주소 형식이 올바르지 않습니다",
		"register18":"이메일 형식 오류",
		"register19":"이메일 인증 코드 오류",
		"register20":"비밀번호는 6~16자로 설정해주세요.",
		"register21":"비밀번호 형식 오류",
		"register22":"두 번 입력하신 비밀번호가 일치하지 않습니다. 다시 입력해 주세요.",
		"register23":"비밀번호를 입력하세요",
		"register24":"등록이 성공했습니다!",
		"register25":"인증 코드 오류",
	},
	recorder:{
		"recorder1":"음성 녹음기 클라우드 디스크",
		"recorder2":"클라우드 공간 용량",
		"recorder3":"문서",
		"recorder331":"휴지통",
		"recorder332":"모두 지우기",
		"recorder4":"이름",
		"recorder5":"오디오 길이",
		"recorder6":"파일 크기",
		"recorder7":"창조 시간",
		"recorder8":"작동하다",
		"recorder9":"클라우드 공간 설명",
		"recorder10":"문서",
		"recorder11":"OCR 파일",
		"recorder12":"1. 클라우드 공간은 무엇에 사용되나요?",
		"recorder13":"레코더에서 녹음한 후, 오디오와 대본 파일을 클라우드 공간에 업로드할 수 있습니다. 레코더가 없어도 클라우드 공간에 접속하여 오디오를 확인할 수 있습니다.",
		"recorder14":"2. 클라우드 공간에 업로드하는 방법은?",
		"recorder15":"녹음기에서 [내 파일]로 이동하여 대상 파일을 선택하고 길게 눌러 옵션을 표시한 다음 &quot;업로드&quot;를 클릭하여 파일을 클라우드 공간에 업로드합니다.",
		"recorder16":"3. 클라우드 공간 파일을 어떻게 보거나 관리하나요?",
		"recorder17":"BeiBo 공식 웹사이트에 로그인하고 &quot;My-Recorder 클라우드 디스크&quot;를 선택하면 업로드된 레코더 파일을 볼 수 있습니다. 다운로드할 대상 파일을 선택하거나 삭제하는 등의 작업을 할 수 있습니다. 클라우드 공간 파일을 삭제하여 클라우드 공간을 정리할 수도 있습니다!",
		"recorder18":"전사되지 않음",
		"recorder19":"요약 보기",
		"recorder20":"스피커",
		"recorder21":"스피커 이름 편집",
		"recorder22":"확신하는",
		"recorder23":"다운로드",
		"recorder24":"콘텐츠 다운로드:",
		"recorder25":"다운로드 설정:",
		"recorder26":"스피커 표시",
		"recorder27":"취소",
		"recorder28":"링크 공유",
		"recorder29":"링크를 받은 사람은 누구나 접근할 수 있습니다. 읽기 전용이며, 링크는 7일 동안 유효합니다.",
		"recorder30":"링크 복사",
		"recorder31":"스캔하여 빠르게 확인하세요",
		"recorder32":"스마트한 조직",
		"recorder33":"스피커를 구별하다",
		"recorder34":"화자 역할에 따라 필사된 텍스트를 지능적으로 구별합니다.",
		"recorder35":"지능형 음성 언어 정규화",
		"recorder36":"모달 입자, 반복 단어 및 일시 정지 단어를 자동으로 필터링합니다.",
		"recorder37":"비음성 필터링",
		"recorder38":"재생 중 음성이나 소음 없이 오디오를 자동으로 건너뜁니다.",
		"recorder39":"선택해주세요",
		"recorder40":"문서",
		"recorder41":"오디오",
		"recorder42":"문서 + 오디오",
		"recorder43":"힌트",
		"recorder44":"이 작업을 수행하면 파일이 삭제됩니다. 계속하시겠습니까?",
		"recorder441":"이 작업을 수행하면 모든 파일이 삭제됩니다. 계속하시겠습니까?",
		"recorder45":"확신하는",
		"recorder46":"취소",
		"recorder47":"성공적으로 삭제되었습니다!",
		"recorder48":"삭제되지 않음",
		"recorder49":"아직 태그가 없습니다",
		"recorder50":"절약...",
		"recorder51":"휴지통",
	},
	personal:{
		"personal1":"계정 설정",
		"personal2":"개인 정보",
		"personal3":"화신",
		"personal4":"파일 업로드",
		"personal5":"JPG, JPEG, GIF, PNG 스타일 지원, 2M 이내의 사진 지원",
		"personal6":"별명",
		"personal7":"별명을 입력해주세요",
		"personal8":"성별",
		"personal9":"신사",
		"personal10":"놓치다",
		"personal11":"기밀 유지",
		"personal12":"생일",
		"personal13":"생일을 선택해주세요",
		"personal14":"직업",
		"personal15":"직업을 선택해주세요",
		"personal16":"직업을 입력해 주세요 (선택사항)",
		"personal17":"국가",
		"personal18":"귀하의 국가를 선택해 주세요",
		"personal19":"저장",
		"personal20":"개인 정보",
		"personal21":"계정 보안",
		"personal22":"2M 이내의 이미지만 지원합니다.",
		"personal23":"업로드가 성공했습니다!",
		"personal24":"수정이 성공했습니다!",
		"personal25":"계정 보안",
		"personal26":"로그인 비밀번호",
		"personal27":"개정하다",
		"personal28":"이메일",
		"personal29":"바꾸다",
		"personal30":"계정 취소",
		"personal32":"정말로 계정을 취소하시겠습니까?",
		"personal33":"로그아웃 후에는 계정 내의 모든 콘텐츠가 삭제되므로 주의해서 진행해주시기 바랍니다.",
		"personal34":"취소",
		"personal35":"확신하는",
		"personal36":"입증",
		"personal37":"본인 확인이 필요하신 경우, 이메일 인증코드를 통해 본인 확인을 완료해 주시기 바랍니다.",
		"personal38":"우편",
		"personal39":"인증 코드",
		"personal40":"인증번호를 입력해주세요",
		"personal41":"다음 단계",
		"personal42":"새 사서함 설정",
		"personal43":"우편",
		"personal44":"새로운 이메일 주소를 입력하세요",
		"personal45":"인증 코드",
		"personal46":"인증번호를 입력해주세요",
		"personal47":"확신하는",
		"personal48":"새로운 로그인 비밀번호를 설정하세요",
		"personal49":"새로운 로그인 비밀번호",
		"personal50":"새로운 비밀번호를 입력하세요",
		"personal51":"새 비밀번호 확인",
		"personal52":"새로운 비밀번호를 다시 입력하세요",
		"personal53":"확신하는",
		"personal54":"얻다",
		"personal55":"이메일 형식 오류",
		"personal56":"교체가 성공했습니다!",
		"personal57":"비밀번호는 6~16자로 설정해주세요.",
		"personal58":"두 번 입력하신 비밀번호가 일치하지 않습니다.",
		"personal59":"수정이 성공했습니다!",
		"personal60":"로그아웃이 성공했습니다!",
	}
}